////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const KioskPricesManagerCampaignStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
	padding: 0px 10px;
`
//////STYLED//////

const KioskPricesManagerCampaignStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskPricesManagerCampaignStatusWrapper colorCode={props.row.campaignStatus.colorCode}>
			{translations[props.row.campaignStatus.translationKey]}
		</KioskPricesManagerCampaignStatusWrapper>
	)
}

KioskPricesManagerCampaignStatus.propTypes = {}

KioskPricesManagerCampaignStatus.defaultPropTypes = {}

export default KioskPricesManagerCampaignStatus
